module.exports = __webpack_public_path__ + "img/index-honor55.4623e646.png";